import { render, staticRenderFns } from "./web-store.vue?vue&type=template&id=c5dceb5c&"
import script from "./web-store.vue?vue&type=script&lang=js&"
export * from "./web-store.vue?vue&type=script&lang=js&"
import style0 from "./web-store.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
